const RELOAD_ATTEMPTED_KEY = 'chunk_load_reload_attempted';

export const registerChunkLoadErrorHandler = () => {
  // https://vite.dev/guide/build#load-error-handling - event generated by vite
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();

    if (sessionStorage.getItem(RELOAD_ATTEMPTED_KEY)) {
      return;
    }

    sessionStorage.setItem(RELOAD_ATTEMPTED_KEY, 'true');
    window.location.reload();
  });
};

export const clearChunkLoadReloadAttempt = () => {
  sessionStorage.removeItem(RELOAD_ATTEMPTED_KEY);
};
